import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/teamss_logo.png")